import { render, staticRenderFns } from "./RelatorioClientesRank.vue?vue&type=template&id=55f7c2cc"
import script from "./RelatorioClientesRank.vue?vue&type=script&lang=js"
export * from "./RelatorioClientesRank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports